import { Badge, ErrorMessage, Spinner } from "../../../../widgets";
import { BadgeProperties, useBadgeProperties } from "./BadgeProperties";
import { ControlType, FetchStatus } from "../../../../base/types";

import { DraftBadgeComponent } from "./DraftBadgeComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const BadgeComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { status, properties, error } = useBadgeProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <>
        <Badge className={className} {...properties}>{children}</Badge>
    </>
}

Registry.addControl({
    id: "234e5c30-eebe-4931-b426-8a11950f98ed",
    name: "Badge",
    type: ControlType.Badge,
    properties: BadgeProperties,
    component: BadgeComponent,
    draftComponent: DraftBadgeComponent
})
